export const FETCH_SURGERY_REQUEST = "FETCH_SURGERY_REQUEST";
export const FETCH_SURGERY_SUCCESS = "FETCH_SURGERY_SUCCESS";
export const FETCH_SURGERY_FAIL = "FETCH_SURGERY_FAIL";

export const CREATE_SURGERY_REQUEST = "CREATE_SURGERY_REQUEST";
export const CREATE_SURGERY_SUCCESS = "CREATE_SURGERY_SUCCESS";
export const CREATE_SURGERY_FAIL = "CREATE_SURGERY_FAIL";

export const UPDATE_SURGERY_REQUEST = "UPDATE_SURGERY_REQUEST";
export const UPDATE_SURGERY_SUCCESS = "UPDATE_SURGERY_SUCCESS";
export const UPDATE_SURGERY_FAIL = "UPDATE_SURGERY_FAIL";

export const FETCH_TYPE_SURGERY_REQUEST = "FETCH_TYPE_SURGERY_REQUEST";
export const FETCH_TYPE_SURGERY_SUCCESS = "FETCH_TYPE_SURGERY_SUCCESS";
export const FETCH_TYPE_SURGERY_FAIL = "FETCH_TYPE_SURGERY_FAIL";

export const SHOW_TYPE_SURGERY_REQUEST = "SHOW_TYPE_SURGERY_REQUEST";
export const SHOW_TYPE_SURGERY_SUCCESS = "SHOW_TYPE_SURGERY_SUCCESS";
export const SHOW_TYPE_SURGERY_FAIL = "SHOW_TYPE_SURGERY_FAIL";

export const CREATE_TYPE_SURGERY_REQUEST = "CREATE_TYPE_SURGERY_REQUEST";
export const CREATE_TYPE_SURGERY_SUCCESS = "CREATE_TYPE_SURGERY_SUCCESS";
export const CREATE_TYPE_SURGERY_FAIL = "CREATE_TYPE_SURGERY_FAIL";

export const UPDATE_TYPE_SURGERY_REQUEST = "UPDATE_TYPE_SURGERY_REQUEST";
export const UPDATE_TYPE_SURGERY_SUCCESS = "UPDATE_TYPE_SURGERY_SUCCESS";
export const UPDATE_TYPE_SURGERY_FAIL = "UPDATE_TYPE_SURGERY_FAIL";

export const FETCH_ORGAN_REQUEST = "FETCH_ORGAN_REQUEST";
export const FETCH_ORGAN_SUCCESS = "FETCH_ORGAN_SUCCESS";
export const FETCH_ORGAN_FAIL = "FETCH_ORGAN_FAIL";

export const CREATE_ORGAN_REQUEST = "CREATE_ORGAN_REQUEST";
export const CREATE_ORGAN_SUCCESS = "CREATE_ORGAN_SUCCESS";
export const CREATE_ORGAN_FAIL = "CREATE_ORGAN_FAIL";

export const UPDATE_ORGAN_REQUEST = "UPDATE_ORGAN_REQUEST";
export const UPDATE_ORGAN_SUCCESS = "UPDATE_ORGAN_SUCCESS";
export const UPDATE_ORGAN_FAIL = "UPDATE_ORGAN_FAIL";

export const GET_SURGERY_BY_IDS_REQUEST = "GET_SURGERY_BY_IDS_REQUEST";
export const GET_SURGERY_BY_IDS_SUCCESS = "GET_SURGERY_BY_IDS_SUCCESS";
export const GET_SURGERY_BY_IDS_FAIL = "GET_SURGERY_BY_IDS_FAIL";

export const SHOW_ORGAN_REQUEST = "SHOW_ORGAN_REQUEST";
export const SHOW_ORGAN_SUCCESS = "SHOW_ORGAN_SUCCESS";
export const SHOW_ORGAN_FAIL = "SHOW_ORGAN_FAIL";


export const FETCH_TYPE_OF_HELP_REQUEST = "FETCH_TYPE_OF_HELP_REQUEST";
export const FETCH_TYPE_OF_HELP_SUCCESS = "FETCH_TYPE_OF_HELP_SUCCESS";
export const FETCH_TYPE_OF_HELP_FAIL = "FETCH_TYPE_OF_HELP_FAIL";

export const CREATE_TYPE_OF_HELP_REQUEST = "CREATE_TYPE_OF_HELP_REQUEST";
export const CREATE_TYPE_OF_HELP_SUCCESS = "CREATE_TYPE_OF_HELP_SUCCESS";
export const CREATE_TYPE_OF_HELP_FAIL = "CREATE_TYPE_OF_HELP_FAIL";

export const UPDATE_TYPE_OF_HELP_REQUEST = "UPDATE_TYPE_OF_HELP_REQUEST";
export const UPDATE_TYPE_OF_HELP_SUCCESS = "UPDATE_TYPE_OF_HELP_SUCCESS";
export const UPDATE_TYPE_OF_HELP_FAIL = "UPDATE_TYPE_OF_HELP_FAIL";
